import { Grid } from '@material-ui/core';
import React from 'react';
import { BaseButton } from 'src/common/components/base-button';
import { ReactComponent as Calculator } from '../../common/media/Calculator.svg';
import { iconStyle } from './toggle-keypad-button-styles';

export const ToggleKeypadButton = ({ toggleKeypad }: ToggleKeypadButtonProps): JSX.Element => {
  const styles = iconStyle();
  return (
    <Grid container justifyContent='flex-end' style={{ width: 'auto' }}>
      <Grid item>
        <BaseButton isSquare onClick={toggleKeypad} data-testid='keypad-open-icon'>
          <Calculator className={styles.icon} />
        </BaseButton>
      </Grid>
    </Grid>
  );
};

export interface ToggleKeypadButtonProps {
  toggleKeypad: () => void;
}
